import { long_text } from "../../mockData/cards";
import './ProductDetails.css'
export default function  ProductDetails(props) {

    const durationHours = props.DurationTime / 60;
    return <div className="ProductDetails card text-start border-0">
        <div className="ProductDetails-body">
            <div className="">
                {props.Title && <h5 className="card-title almoni_tzar_bold">{props.Title}</h5>}
                {props.Subtitle && <h6 className="card-subtitle mb-2 text-muted">{props.Subtitle}</h6>}

            </div>
            <div className="row mx-0 mb-3">
                <div className="col-4 d-flex align-items-center gx-0">
                    <div className="duration d-inline-block me-2"></div>
                    <span className="text-mahuti fw-bold">
                        {`${props.DurationTime || ''} דקות`}
                    </span>
                </div>
                <div className="col-8 d-flex align-items-center gx-0">
                    <i className="currency d-inline-block  me-2"></i>
                    <div className="text-start text-mahuti">
                        <span className="me-2 fw-bold">{props.price?.underAge || ''} ₪ לילד</span>
                        <span>(מבוגר {props.price?.adults || ''} ₪)</span>  
                    </div>
                </div>
            </div>

            <div className="border border-end-0 border-start-0 border-top-0 d-lg-none d-block mb-3 pb-1"></div>

            <p className="card-text text-mahuti">{props.Description}</p>
        </div>
    </div>
}